import styled from 'styled-components';

import {
  BreakPoint,
  Color,
  Font,
  FontSize,
} from '../../../../phase2/survey/asset/styles';

import {
  StyledIcon,
  StyledTitle,
} from '../../../../phase2/survey/page/thanks/style';

export const StyledWrapper = styled.div(
  props => `
  width: 100%;
  background-color: ${Color.white};
  /*
  desktop 表示 / mobile 非表示
  */
  display: ${props.desktop ? 'block' : 'none'};
 
`
);

export const StyledBox = styled.div`
  color: ${Color.text.black};
  font-family: ${Font.default};
  padding: 16px;
  box-sizing: border-box;
  /*
  max-width: ${BreakPoint.desktop};
  margin: 0 auto;
  */
  display: flex;
  align-items: center;
  flex-direction: column;

  * {
    font-family: ${Font.default};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const StyledEmbeddedIcon = styled(StyledIcon)`
  margin-top: 0;
`;
export const StyledEmbeddedTitle = styled(StyledTitle)`
  margin-top: 0;
  /* UXDCOEIPS-370: Add flex-basis for IE11 */
  flex-basis: auto;
`;

export const StyledMessage = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  display: flex;
  justify-content: center;
  word-break: break-all;
`;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/thanks/style.js